module.exports = __webpack_public_path__ + "img/hit01.af32444a.png";